import DeviceManager from '../utils/device-manager';
import Sticky from '../utils/stickyjs';
import Header from './header';

const FaqList = {
    init() {

        document.querySelectorAll('.js-faq-list').forEach($faq => {
            const $navItems = $faq.querySelectorAll('.js-faq-list-nav-item');
            const $sections = $faq.querySelectorAll('.js-faq-list-section');
            const $togglers = $faq.querySelectorAll('.js-faq-list-question-toggler');
            const $selectSEction = $faq.querySelector('#faq-list-select');

            // console.log($sections);

            $togglers.forEach($toggler => {
                $toggler.addEventListener('click', e => {
                    $toggler.parentNode.classList.toggle('closed');
                });
            });

            if ($selectSEction) {
                $selectSEction.addEventListener('change', e => {
                    // console.log ($selectSEction.value);
                    // Header.smoothScroll($selectSEction.value);
                    $sections.forEach ($section => {
                        $section.classList.remove('show');
                    });

                    document.querySelector($selectSEction.value).classList.add('show');
                });
            }
            
            const faq_list = document.querySelectorAll('.js-faq-list-nav-item');

            faq_list.forEach(item => {
                item.addEventListener("click", _event => {
                    // console.log (_event);
                    // this.smoothScrollEvent = _event;
                    Header.smoothScroll (_event.target.hash, _event);
                    
                });
            });

            $sections.forEach($section => {
                $section.querySelectorAll('.js-faq-list-question').forEach(($question, index) => {
                    $question.querySelectorAll('.js-faq-list-response').forEach($response => {
                        const calcResponseHeight = () => {
                            const isClosed = $question.classList.contains('closed');
                            $question.classList.remove('closed');
                            $question.classList.add('open');

                            // $response.style.maxHeight = '';
                            // $response.style.maxHeight = $response.clientHeight + 'px';

                            $question.classList.remove('open');

                            if (isClosed) {
                                $question.classList.add('closed');
                            }
                        };

                        DeviceManager.addWindowCallback(calcResponseHeight);

                        if (index > 0) {
                            $question.classList.add('closed');
                        }
                    });
                });
            });
            
            // console.log($navItems);

            $navItems.forEach($navItem => {
                // console.log($navItem);
                const nav = $navItem.dataset.nav;
                // const $section = Array.from($sections).filter(s => s.dataset.section === nav)[0];
                let $tempSections = [];
                [].forEach.call($sections, ($s) => {
                    if ($s.dataset.section === nav) {
                        // console.log('section: ', $s.dataset.section, nav);
                        $tempSections.push($s);
                    }
                });
                const $section = $tempSections[0];
 
                const observer = new IntersectionObserver(entries => {
                    // console.log( "Log = ",$navItem, entries[0]['intersectionRatio']);
                    $navItem.setAttribute('data-ratio', entries[0]['intersectionRatio']);
                    /* console.log("Nav = ", $navItem.getAttribute('data-ratio')); */
                }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
                
                // Observe element only if currentDevice >= md
                // let isObserved = false;
                // appliquer directement l'observation pour toutes les largeurs de window
                observer.observe($section);
                // isObserved = true;
                /* DeviceManager.addCallback(attr => {
                    if (isObserved === false && DeviceManager.isGreaterThan(attr.current, 'sm')) {
                        observer.observe($section);
                        isObserved = true;
                    } else if (isObserved === true) {
                        observer.unobserve($section);
                        isObserved = false;
                    }
                }); */
            });
        });

        var sticky = new Sticky('.sticky');
        window.addEventListener('resize', () => {
            sticky.update();
            
            // set time out event faq item
            settimeout_event_faq_item();

            // event scrolling class active
            event_scroll_active();
        });
        
        if(document.querySelectorAll('.js-faq-list').length != 0){
            
            settimeout_event_faq_item();

            event_scroll_active();
        }

        function event_active_faq_item(){
            document.querySelectorAll('.js-faq-list').forEach($faq => {
                const $navItems = $faq.querySelectorAll('.js-faq-list-nav-item');
                var $biggest = null;
                $navItems.forEach($navItem => {
                    // console.log( "data-ratio = ", $navItem.getAttribute('data-ratio'));
                    if( $biggest == null || $biggest.getAttribute('data-ratio') < $navItem.getAttribute('data-ratio')){
                        $biggest = $navItem; 
                    }
                    $navItem.classList.remove('active');
                }); 
                if( $biggest!=null){
                    $biggest.classList.add('active');
                }
            }); 
        }
        
        function settimeout_event_faq_item(timeout = 1000){
            setTimeout(function(){ 
                event_active_faq_item();
            }, timeout); 
        }

        function event_scroll_active(){
            window.addEventListener('scroll', function(e) {
                settimeout_event_faq_item(125);
            });
        }
      
    }
}

export default FaqList;